import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedVerification = _resolveComponent("SharedVerification")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedWindow = _resolveComponent("SharedWindow")!

  return (_openBlock(), _createBlock(_component_SharedWindow, {
    class: _normalizeClass(_ctx.b()),
    title: "Подтверждение вывода через email",
    "is-big": true,
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('wrapper'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('label'))
        }, _toDisplayString(_ctx.$t("Проверьте данные для перевода:")), 3),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('label'))
        }, _toDisplayString(_ctx.$t("Кошелек:")), 3),
        _createElementVNode("b", {
          class: _normalizeClass(_ctx.b('label', { withdraw: true }))
        }, _toDisplayString(_ctx.modal.address), 3),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('label'))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("Сеть:")), 1),
          _createElementVNode("b", {
            class: _normalizeClass(_ctx.b('label', { withdraw: true }))
          }, _toDisplayString(_ctx.modal.network), 3)
        ], 2),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('label'))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("Cумма:")), 1),
          _createElementVNode("b", {
            class: _normalizeClass(_ctx.b('label', { withdraw: true }))
          }, _toDisplayString(_ctx.modal.amount), 3),
          _createElementVNode("b", {
            class: _normalizeClass(_ctx.b('label', { withdraw: true }))
          }, _toDisplayString(_ctx.modal.currencyName), 3)
        ], 2),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('label'))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("Вы получите")), 1),
          _createElementVNode("b", {
            class: _normalizeClass(_ctx.b('label', { withdraw: true }))
          }, _toDisplayString(_ctx.modal.total), 3),
          _createElementVNode("b", {
            class: _normalizeClass(_ctx.b('label', { withdraw: true }))
          }, _toDisplayString(_ctx.modal.currencyName), 3)
        ], 2),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('label'))
        }, _toDisplayString(_ctx.$t("Код-подтверждение отправлен на email")), 3),
        _createVNode(_component_SharedVerification, {
          class: _normalizeClass(_ctx.b('verification')),
          label: "Введите 6 цифр из сообщения на email",
          code: _ctx.code,
          "onUpdate:code": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
          "is-error": false
        }, null, 8, ["class", "code"]),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(_ctx.b('error'))
            }, _toDisplayString(_ctx.errorMessage), 3))
          : _createCommentVNode("", true),
        _createVNode(_component_UIButton, {
          label: "Подтвердить",
          view: "main",
          disabled: _ctx.isConfirmDisabled,
          onClick: _ctx.handleVerification
        }, null, 8, ["disabled", "onClick"])
      ], 2)
    ]),
    _: 1
  }, 8, ["class", "onClose"]))
}